import {globals, page as pageIndex} from '../../globals'
import {
  actionHandler,
  UPDATE_DATA
} from './updateData'
import {GET_COUNTRY_REGIONS_FETCHED} from './regions'
import {logOut} from "./auth";
import {hideModal, showModal} from "./modal";
import {getUniqueListBy} from "./helpers";
// ------------------------------------
// Constants
// ------------------------------------
export const SET_EDIT_MODAL_CONTENT_A = 'SET_EDIT_MODAL_CONTENT_A'
export const RESET_NEW_MODAL_CONTENT = 'RESET_NEW_MODAL_CONTENT'
export const GET_ACTION_HELP_TEXT_START = 'GET_ACTION_HELP_TEXT_START'
export const GET_ACTION_HELP_TEXT_FETCHED = 'GET_ACTION_HELP_TEXT_FETCHED'
export const GET_ACTION_HELP_TEXT_FAILED = 'GET_ACTION_HELP_TEXT_FAILED'
export const REMOVE_ACTION_HELP_TEXT_START = 'REMOVE_ACTION_HELP_TEXT_START'
export const REMOVE_ACTION_HELP_TEXT_SUCCESS = 'REMOVE_ACTION_HELP_TEXT_SUCCESS'
export const REMOVE_ACTION_HELP_TEXT_FAILURE = 'REMOVE_ACTION_HELP_TEXT_FAILURE'
export const ADD_ACTION_HELP_TEXT_START = 'ADD_ACTION_HELP_TEXT_START'
export const ADD_ACTION_HELP_TEXT_SUCCESS = 'ADD_ACTION_HELP_TEXT_SUCCESS'
export const ADD_ACTION_HELP_TEXT_FAILURE = 'ADD_ACTION_HELP_TEXT_FAILURE'
export const UPDATE_ACTION_HELP_TEXT_START = 'UPDATE_ACTION_HELP_TEXT_START'
export const UPDATE_ACTION_HELP_TEXT_SUCCESS = 'UPDATE_ACTION_HELP_TEXT_SUCCESS'
export const UPDATE_ACTION_HELP_TEXT_FAILURE = 'UPDATE_ACTION_HELP_TEXT_FAILURE'
export const GET_HISTORY_TEXT_HISTORY_START = 'GET_HISTORY_TEXT_HISTORY_START'
export const GET_HISTORY_TEXT_HISTORY_FAILURE = 'GET_HISTORY_TEXT_HISTORY_FAILURE'
export const GET_HISTORY_TEXT_HISTORY_SUCCESS = 'GET_HISTORY_TEXT_HISTORY_SUCCESS'
export const FILTER_HISTORY_TEXT_HISTORY = 'FILTER_HISTORY_TEXT_HISTORY'
// ------------------------------------
// Actions
// ------------------------------------


const headers = {
  'Content-Type': 'application/json'
}

export function removeHistoryTextAction(id) {
  return (dispatch) => {
    dispatch({type: REMOVE_ACTION_HELP_TEXT_START})
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    fetch(`${globals.apiUrl}/HistoryActionHelpText/${id}`, options).then((response) => {
      if (response.status === 200) {
        return response.text()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then(() => {
      dispatch({
        type: REMOVE_ACTION_HELP_TEXT_SUCCESS,
        id
      })
      dispatch(hideModal('Delete-history-action'))
      dispatch(historyActionDataInit())
    }).catch((err) => {
      console.log(err)
      dispatch({type: REMOVE_ACTION_HELP_TEXT_FAILURE})
    })
  }
}

export function createHistoryTextAction(textActionInfo) {
  return (dispatch) => {
    dispatch({type: ADD_ACTION_HELP_TEXT_START})
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(textActionInfo)
    }
    fetch(`${globals.apiUrl}/HistoryActionHelpText`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      dispatch({
        type: ADD_ACTION_HELP_TEXT_SUCCESS,
        textActionInfo: json
      })
      dispatch(hideModal('Add-new-item-history-action'))
      dispatch(historyActionDataInit())
    }).catch((err) => {
      console.log(err)
      dispatch({type: ADD_ACTION_HELP_TEXT_FAILURE})
    })
  }
}

export function setResetHistoryModal(historyObj) {
  if (historyObj) {
    return {
      type: SET_EDIT_MODAL_CONTENT_A,
      historyObj
    }
  } else {
    return {
      type: RESET_NEW_MODAL_CONTENT
    }
  }
}

export function historyActionDataInit() {
  return (dispatch) => {
    dispatch({type: GET_ACTION_HELP_TEXT_START})
    const options = {
      method: 'GET',
      credentials: 'include',
    }
    fetch(`${globals.apiUrl}/HistoryActionHelpText`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_ACTION_HELP_TEXT_FETCHED,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({type: GET_ACTION_HELP_TEXT_FAILED})
    })
  }
}

function returnHistoryText(historyTextData) {
  return historyTextData.map(item => {
      return {
        value: item,
        label: item
      }
    })

}

export function updateHistoryTextAction(textActionInfo) {
  return (dispatch) => {
    dispatch({type: UPDATE_ACTION_HELP_TEXT_START})
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(textActionInfo)
    }
    fetch(`${globals.apiUrl}/HistoryActionHelpText`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({type: UPDATE_ACTION_HELP_TEXT_FAILURE, json: text})
            dispatch(showModal('Error'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        if (json.Message) {
          dispatch({type: UPDATE_ACTION_HELP_TEXT_FAILURE, json: json.Message})
          dispatch(showModal('Error'))
        } else {
          dispatch({
            type: UPDATE_ACTION_HELP_TEXT_SUCCESS,
            textActionInfo: json
          })
          dispatch(hideModal('Edit-item-history-action'))
          dispatch(historyActionDataInit())
        }
      }
    }).catch((err) => {
      console.log(err)
      dispatch({type: UPDATE_ACTION_HELP_TEXT_FAILURE, json: err})
    })
  }
}

export function getAgencyHistory(searchOptions) {
  return (dispatch) => {
    dispatch({type: GET_HISTORY_TEXT_HISTORY_START})
    const options = {
      method: 'GET',
      credentials: 'include',
      headers
    }
    const setSearchOptions = searchOptions ? `?search=${searchOptions.split(' ').join('*')}` : ''
    fetch(`${globals.apiUrl}/HistoryActionHelpTextHistory${setSearchOptions}`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 401) {
        dispatch(logOut())
      } else if (response.status === 400) {
        response.text().then((text) => {
          if (text) {
            dispatch({type: GET_HISTORY_TEXT_HISTORY_FAILURE, json: text})
            dispatch(showModal('Error'))
          }
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: GET_HISTORY_TEXT_HISTORY_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({type: GET_HISTORY_TEXT_HISTORY_FAILURE, json: err})
    })
  }
}
const sortOrderAdnState = (arr) => {
  return arr.sort((a, b) => {
    if(a.state === b.state) {
      return a.Sort - b.Sort
    }
    return  a.state > b.state ? 1 : -1;
  })
}

export function filterHelpActionText(actionHelpText, id) {
  return {
    type: FILTER_HISTORY_TEXT_HISTORY,
    actionHelpText,
    id
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) => action.location.page !== pageIndex.historyHelpText
    ? state : actionHandler(state, action),
  [GET_COUNTRY_REGIONS_FETCHED]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allStates: [{label: 'All States', value: '*'},
          ...action.payload.json.map(item => {
            return {
              value: item.ShortName,
              label: item.Name
            }
          })]
      }
    }
  },
  [RESET_NEW_MODAL_CONTENT]: (state) => {
    return {
      ...state,
      formDataValue: {
        [pageIndex.historyHelpText]: {
          ...state.formDataValue[pageIndex.historyHelpText],
          modalContent: {
            ...initialState.formDataValue[pageIndex.historyHelpText].modalContent
          }
        }
      }
    }
  },
  [SET_EDIT_MODAL_CONTENT_A]: (state, action) => {
    const {state: State, Action, ActionWords, Sort} = action.historyObj
    return {
      ...state,
      formDataValue: {
        HHT: {
          ...state.formDataValue[pageIndex.historyHelpText],
          modalContent: {
            radio: {
              state: State,
              historyText: Action
            },
            textValues: {
              historyAction: ActionWords,
              sort: Sort
            }
          }
        }
      }
    }
  },
  [GET_ACTION_HELP_TEXT_START]: (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [GET_ACTION_HELP_TEXT_FAILED]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [GET_ACTION_HELP_TEXT_FETCHED]: (state, action) => {
    const {json} = action.payload
    const existedStates = [...new Set(json.map(item => item.state))]
    const existedStrings = !state.renderData.actionHelpTextDataFiltered ? [...new Set(json.map(item => item.Action))] : [...new Set(state.renderData.actionHelpTextDataFiltered.map(item => item.Action))]
    const stringsMocked = [...new Set(json.map(item => item.Action))]

    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        actionHelpTextData: sortOrderAdnState(json),
        actionHelpTextStrings: returnHistoryText(existedStrings),
        actionHelpTextStringsForModal: returnHistoryText([...new Set(json.map(item => item.Action))]),
        existedStates,
        existedStrings: stringsMocked
      }
    }
  },
  [GET_HISTORY_TEXT_HISTORY_START]: (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        isFetchingData: true,
        history: undefined
      }
    }
  },
  [GET_HISTORY_TEXT_HISTORY_SUCCESS]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        isFetchingData: false,
        history: action.payload.json
      }
    }
  },
  [GET_HISTORY_TEXT_HISTORY_FAILURE]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [UPDATE_ACTION_HELP_TEXT_START]: (state) => {
    return {
      ...state
    }
  },
  [UPDATE_ACTION_HELP_TEXT_FAILURE]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [UPDATE_ACTION_HELP_TEXT_SUCCESS]: (state, action) => {
    const {textActionInfo} = action
    let actionHelpList = state.renderData.actionHelpTextData
    let actionHelpListFiltered = state.renderData.actionHelpTextDataFiltered
    let historyActionHelpRecordsFiltered
    if(actionHelpListFiltered) {
      historyActionHelpRecordsFiltered = actionHelpListFiltered.map(item => {
        if (item.id === textActionInfo.id) {
          return textActionInfo
        } else return item
      })
    }
    const historyActionHelpRecords = actionHelpList.map(item => {
      if (item.id === textActionInfo.id) {
        return textActionInfo
      } else return item
    })
    if(state.formDataValue.HHT.queryLine.radio.state !== '*') {
      historyActionHelpRecordsFiltered = historyActionHelpRecordsFiltered.filter(item => {
        if(item.state === state.formDataValue.HHT.queryLine.radio.state) {
          return item
        } else {
          return null
        }
      })
    }
    return {
      ...state,
      renderData: {
        ...state.renderData,
        actionHelpTextData: sortOrderAdnState(historyActionHelpRecords),
        actionHelpTextDataFiltered: actionHelpListFiltered ? sortOrderAdnState(historyActionHelpRecordsFiltered) : sortOrderAdnState(historyActionHelpRecords)
      }
    }
  },
  [ADD_ACTION_HELP_TEXT_START]: (state) => {
    return {
      ...state
    }
  },
  [ADD_ACTION_HELP_TEXT_FAILURE]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [ADD_ACTION_HELP_TEXT_SUCCESS]: (state, action) => {
    let currentHistoryActionData = state.renderData.actionHelpTextData
    const {textActionInfo} = action
    currentHistoryActionData = textActionInfo ? [textActionInfo, ...currentHistoryActionData] : currentHistoryActionData
    return {
      ...state,
      renderData: {
        ...state.renderData,
        actionHelpTextData: sortOrderAdnState(currentHistoryActionData),
        actionHelpTextDataFiltered: textActionInfo && state.renderData.actionHelpTextDataFiltered ? sortOrderAdnState([textActionInfo, ...state.renderData.actionHelpTextDataFiltered]) : sortOrderAdnState(currentHistoryActionData)
      }
    }
  },
  [REMOVE_ACTION_HELP_TEXT_START]: (state) => {
    return {
      ...state
    }
  },
  [REMOVE_ACTION_HELP_TEXT_SUCCESS]: (state, action) => {
    const {id} = action
    return {
      ...state,
      renderData: {
        ...state.renderData,
        actionHelpTextData: state.renderData.actionHelpTextData.filter(item => item.id !== id),
        actionHelpTextDataFiltered: state.renderData.actionHelpTextDataFiltered && state.renderData.actionHelpTextDataFiltered.filter(item => item.id !== id)
      }
    }
  },
  [REMOVE_ACTION_HELP_TEXT_FAILURE]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json
    }
  },
  [FILTER_HISTORY_TEXT_HISTORY]: (state, action) => {
    let historyActionHelpTexts = state.renderData.actionHelpTextData;
    let historyActionStringsFiltered;
    let historyActionHelpTextsFiltered;
    const selectedState = action.actionHelpText
    if(action.actionHelpText.state !== '*') {
      historyActionHelpTextsFiltered= historyActionHelpTexts.filter(item => item.state === selectedState.state)
      historyActionStringsFiltered = historyActionHelpTextsFiltered.map(item => item.Action)
    } else {
      historyActionStringsFiltered = historyActionHelpTexts.map(item => item.Action)
    }
    if(action.actionHelpText.progress !== '*') {
      historyActionHelpTextsFiltered = historyActionHelpTexts.filter(item => item.Action === selectedState.progress)
    }
    if(action.actionHelpText.state !== '*' && action.actionHelpText.progress !== '*') {
      historyActionHelpTextsFiltered = historyActionHelpTexts
        .filter(item => item.Action === selectedState.progress)
        .filter(item => item.state === selectedState.state)
    }
    if(action.actionHelpText.state === '*' && action.actionHelpText.progress === '*') {
      historyActionHelpTextsFiltered = state.renderData.actionHelpTextData;
    }

    const filteredStrings = [...new Set(historyActionStringsFiltered)]

    return {
      ...state,
      renderData: {
        ...state.renderData,
        actionHelpTextDataFiltered: historyActionHelpTextsFiltered,
        actionHelpTextStrings: returnHistoryText(filteredStrings),
        existedStates: [...new Set(historyActionHelpTexts.map(item => item.state))]
      }
    }
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  isFetchingData: false,
  errorCode: '',
  renderData: {
    actionHelpTextData: {}
  },
  formDataValue: {
    [pageIndex.historyHelpText]: {
      queryLine: {
        radio: {
          state: '*',
          historyAction: '*'
        }
      },
      modalContent: {
        radio: {
          state: '',
          historyText: ''
        },
        textValues: {
          historyAction: '',
          sort: ''
        }
      }
    }
  }
}

export default function historyHelpTextReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/historyActionHelpText.js